'use client';

import {
  ColorSwatchPicker as HeroColorSwatchPicker,
  Color,
  parseColor,
} from '@heroui/react';

export interface ColorOption {
  label: string;
  value: string;
}

export interface ColorSwatchPickerProps {
  options: ColorOption[];
  value?: string;
  onChange?: (colorValue: string) => void;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'circle' | 'square';
}

export const ColorSwatchPicker = ({
  options,
  value,
  onChange,
  size = 'md',
  variant = 'circle',
}: ColorSwatchPickerProps) => {
  const currentValue = value ? parseColor(value) : undefined;

  return (
    <HeroColorSwatchPicker
      value={currentValue}
      onChange={(val: Color) => onChange?.(val.toString('hex'))}
      size={size}
      variant={variant}
    >
      {options.map((option) => (
        <HeroColorSwatchPicker.Item key={option.value} color={option.value}>
          <HeroColorSwatchPicker.Swatch />
          <HeroColorSwatchPicker.Indicator />
        </HeroColorSwatchPicker.Item>
      ))}
    </HeroColorSwatchPicker>
  );
};
